import api from './api'
import { WithdrawalSettings } from '../types/AppSettings'

const appSettingsService = {
  async getWithdrawalSettings(): Promise<WithdrawalSettings> {
    const { data } = await api.get('/v1/app-settings/withdrawals')
    return data
  },
}

export default appSettingsService
